import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Backdrop, Grid, Typography, Button, IconButton, Dialog, DialogActions, DialogContent, CircularProgress, Stack, Select, MenuItem, Divider, Snackbar } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import PrintIcon from '@mui/icons-material/Print';
// project imports
import { Delete } from '@mui/icons-material';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import Alert from 'src/components/Alert';
import { Model } from 'survey-core';
import 'survey-core/modern.css';
import 'survey-core/i18n/turkish';
import ServiceDigitalForms from 'src/components/ServiceDigitalForms';
import ServiceDigitalFormsPrint from 'src/components/ServiceDigitalFormsPrint';

// ==============================|| PROFILE 1 -ServiceForms ||============================== //

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    }),
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    confirmOverlay: {
        zIndex: 9999 + ' !important'
    },
    noDisplayInPrint: {
        '@media print': {
            display: 'none'
        }
    },
    button: (theme) => ({
        margin: theme.spacing(1)
    })
};


const ServiceForms = ({ ServiceShopId, ServiceShopFullName }) => {
    const theme = useTheme();
    const [documents, setDocuments] = useState([]);
    const [newDocumentType, setnewDocumentType] = useState('');
    const [newDocument, setNewDocument] = useState(0);
    const SessionUser = getUser();
    const [anketData, setAnketData] = useState({});
    const [formData, setFormData] = useState({});
    const [anketBitti, setAnketBitti] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mesaj, setMesaj] = useState('Form Başarıyla Tamamlandı.');
    const [anketGoster, setAnketGoster] = useState(false);
    const [alert, setAlert] = React.useState(false);
    const [alertType, setAlertType] = React.useState('success');
    const [alertMessage, setAlertMessage] = React.useState('');

    const [formCategories, setFormCategories] = useState([]);
    const [formTypes, setFormTypes] = useState([]);

    const [readOnly, setReadOnly] = useState(false);
    const [printAnket, setPrintAnket] = useState(false);
    const [openedFormType, setOpenedFormType] = useState(0);

    const [serviceCodeQuestion, setServiceCodeQuestion] = useState('');
    const [serviceNameQuestion, setServiceNameQuestion] = useState('');
    const [serviceFullNameQuestion, setServiceFullNameQuestion] = useState('');

    useEffect(() => {
        getServiceFormCategories();
        GetApolloForm();
    }, []);

    const survey = new Model(anketData);
    survey.locale = 'tr';


    const getServiceFormCategories = () => {
        setLoading(true);
        axios.get('getServiceFormCategories')
            .then((response) => {
                setFormCategories(response.data.FormCategory);
                setFormTypes(response.data.FormTypes);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }

    const handleAnketBitti = (MesajParam = "Form başarıyla kaydedildi.") => {
        setAnketBitti(true);
        setMesaj(MesajParam);
        GetApolloForm();
    };


    const GetApolloForm = () => {
        setLoading(true);
        axios.get(`GetApolloForm/${ServiceShopId}`).then((response) => {
            if (Array.isArray(response.data)) {
                setDocuments(response.data);
            } else {
                setDocuments([]);
            }
            setLoading(false);
        });
    }


    const onComplete = (survey) => {
        setLoading(true);
        var denetlemeTarihi = "";
        var terminTarihi = "";
        var denetlemeTarihiFormatted;
        var terminTarihiFormatted;
        var OlumsuzGozlem = false;
        var OlumsuzGozlemAdet = 0;



        if (newDocument == 3 || newDocument == 99) {
            denetlemeTarihi = survey.data.question3 || "";
            terminTarihi = survey.data.question19 || "";
            const [denetlemeYear, denetlemeMonth, denetlemeDay] = denetlemeTarihi.split('-');
            const [terminYear, terminMonth, terminDay] = terminTarihi.split('-');
            denetlemeTarihiFormatted = denetlemeYear && denetlemeMonth && denetlemeDay ? `${denetlemeDay}.${denetlemeMonth}.${denetlemeYear}` : "";
            terminTarihiFormatted = terminYear && terminMonth && terminDay ? `${terminDay}.${terminMonth}.${terminYear}` : "";
            OlumsuzGozlem = Object.values(survey.data.question4).includes("Column 4")
                ||
                Object.values(survey.data.question9).includes("Column 4")
                ||
                Object.values(survey.data.question6).includes("Column 4")
                ||
                Object.values(survey.data.question8).includes("Column 4")
                ||
                Object.values(survey.data.question10).includes("Column 4")
                ||
                Object.values(survey.data.question11).includes("Column 4")
                ||
                Object.values(survey.data.question12).includes("Column 4")
                ||
                Object.values(survey.data.question13).includes("Column 4")
                ||
                Object.values(survey.data.question18).includes("Column 4")
                ||
                Object.values(survey.data.question17).includes("Column 4")
                ||
                Object.values(survey.data.question23).includes("Column 5")
                ||
                Object.values(survey.data.question33).includes("Column 4")
                ||
                Object.values(survey.data.question32).includes("Column 4")
            const OlumsuzGozlemAdet =
                (Object.values(survey.data.question4).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question9).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question6).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question8).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question10).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question11).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question12).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question13).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question18).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question17).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question23).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question33).includes("Column 4") ? 1 : 0) 
                +
                (Object.values(survey.data.question32).includes("Column 4") ? 1 : 0);

        }

        const data = {
            FormData: JSON.stringify(survey.data),
            FormType: newDocument,
            ServiceShopId: ServiceShopId,
            UserId: SessionUser.UserId,
            Type: 1,
            InspectionDate: denetlemeTarihiFormatted,
            TerminDate: terminTarihiFormatted,
            NegativeObservation: OlumsuzGozlem,
            NegativeObservationCount: OlumsuzGozlemAdet
        };
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios.post(`/SetApolloForm`, data, config)
            .then(() => {
                handleAnketBitti();
                setLoading(false);

            })
    };

    const handleAnketKapat = () => {
        setAnketGoster(false);
    }

    const handleCreateForm = () => {
        if (newDocument == 0 || newDocument == undefined) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Lütfen oluşturmak istediğiniz formu seçiniz!..');
            return;
        }
        const anketDataParam = formTypes.filter(x => x.Id == newDocument)
        setAnketData(anketDataParam[0].Data);
        setServiceCodeQuestion(anketDataParam[0].ServiceCodeQuestion);
        setServiceNameQuestion(anketDataParam[0].ServiceNameQuestion);
        setServiceFullNameQuestion(anketDataParam[0].ServiceFullNameQuestion);
        setAnketGoster(true);
        setReadOnly(false);
        setFormData({});
        setAnketBitti(false);
    }
    const closeAlert = () => {
        setAlert(false);
    }

    const handleFormDelete = (id) => {

        confirmAlert({
            message: "Form silinecektir!... Devam etmek istediginizden emin misiniz?",
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => handleFormDeleteParam(id)
                },
                {
                    label: 'Hayır',
                    onClick: () => { return; }
                }
            ]
        });
    };


    const handleFormDeleteParam = (id) => {
        setLoading(true);
        const data = {
            FormData: "",
            FormType: id,
            ServiceShopId: ServiceShopId,
            UserId: SessionUser.UserId,
            Type: 3
        };
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios.post(`/SetApolloForm`, data, config)
            .then(() => {
                handleAnketBitti();
                setLoading(false);
            });
    };

    const handleDownload = async (fileId, FileName) => {
        try {
            setLoading(true);
            const response = await axios.get(`GetApolloFormPdf/${fileId}`);
            const base64String = response.data;


            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = FileName + '.pdf'
            link.click();
            setLoading(false);
        } catch (error) {
            console.error('Error downloading PDF:', error);
            setLoading(false);
        }
    };



    return (
        <div>
            {
                loading ?
                    <Backdrop style={styles.backdrop} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    : <div></div>
            }
            <Snackbar open={alert} autoHideDuration={10000} onClose={closeAlert}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={closeAlert} variant={alertType} message={alertMessage}>
                </Alert>
            </Snackbar>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Typography variant="h5" sx={{ mb: 2 }}>{ServiceShopFullName}</Typography>
                        <Grid container spacing={4}>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}>
                                <Typography variant="h6" sx={{ mb: 1 }}>Dijital Formlar</Typography>
                                <Divider sx={{ mb: 2 }} />
                                {documents.length > 0 ? (
                                    <Stack divider={<Divider />} spacing={1.5}>
                                        {documents.map((document) => (
                                            <Grid container alignItems="center" key={document.ID}>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 6
                                                    }}>
                                                    <Typography>{document.FormAciklama}</Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 3,
                                                        md: 3
                                                    }}>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {document.ACIKLAMA}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 3,
                                                        md: 3
                                                    }}>
                                                    <Stack direction="row" spacing={0} justifyContent="flex-end" alignItems="center">
                                                        {document.DosyaId && document.DosyaId != 0 ?
                                                            <IconButton
                                                                onClick={() => {
                                                                    handleDownload(document.DosyaId, document.FormAciklama);
                                                                }}>
                                                                <PrintIcon style={{ color: '#FF9800' }} />
                                                            </IconButton> : <></>
                                                        }
                                                        <IconButton onClick={() => {
                                                            setPrintAnket(false);
                                                            setReadOnly(true);
                                                            setAnketGoster(true);
                                                            setAnketData(document.AnketSoru);
                                                            setFormData(document.AnketCevap);
                                                            setServiceCodeQuestion('');
                                                            setServiceNameQuestion('');
                                                            setServiceFullNameQuestion('');
                                                            setAnketBitti(false);
                                                        }}>
                                                            <DescriptionIcon style={{ color: '#FF9800' }} />
                                                        </IconButton>
                                                        {SessionUser.ManagementRoleId == 2 || SessionUser.ManagementRoleId == 1 ?
                                                            <IconButton
                                                                onClick={() => handleFormDelete(document.ID)}

                                                            >
                                                                <Delete style={{ color: 'red' }} />
                                                            </IconButton>
                                                            : null}
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Stack>
                                ) : (
                                    <Typography color="text.secondary">Kayıtlı form bulunmamaktadır.</Typography>
                                )}
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 6
                                }}
                                sx={{
                                    borderLeft: { md: '1px solid' },
                                    borderColor: 'divider',
                                    pl: { md: 4 }
                                }}>
                                <Typography variant="h6" sx={{ mb: 1 }}>Yeni Form Oluştur</Typography>
                                <Divider sx={{ mb: 2 }} />
                                    <Grid container spacing={2}>
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 12,
                                                md: 6
                                            }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel htmlFor="outlined-age-native-simple">Form Tipi</InputLabel>
                                                <Select
                                                    label="Form Tipi"
                                                    value={newDocumentType}
                                                    onChange={(e) => setnewDocumentType(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    inputProps={{
                                                        name: 'age',
                                                        id: 'outlined-age-native-simple',
                                                    }}
                                                >
                                                    {formCategories.map((type) => (
                                                        <MenuItem key={type.Id} value={type.Id}>
                                                            {type.Dsc}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 12,
                                                md: 6
                                            }}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel htmlFor="outlined-age-native-simple">Form Adı</InputLabel>
                                                <Select
                                                    label="Form Adı"
                                                    value={newDocument}
                                                    onChange={(e) => setNewDocument(e.target.value)}
                                                    fullWidth
                                                    inputProps={{
                                                        name: 'age',
                                                        id: 'outlined-age-native-simple',
                                                    }}
                                                >
                                                    {formTypes
                                                        .filter((document) => document.CategoryId === newDocumentType)
                                                        .map((document) => (
                                                            <MenuItem key={document.Id} value={document.Id}>
                                                                {document.Dsc}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid
                                            style={{ textAlign: "right" }}
                                            size={{
                                                xs: 12,
                                                sm: 12,
                                                md: 12
                                            }}>
                                            {SessionUser.ManagementRoleId == 2 || SessionUser.ManagementRoleId == 1 ?
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    style={{ textTransform: 'none' }}
                                                    endIcon={<SaveAltIcon />}
                                                    onClick={() => handleCreateForm()}
                                                    sx={{ display: SessionUser.ManagementRoleId != 2 ? 'none' : 'block' }}
                                                >
                                                    Oluştur
                                                </Button>
                                                : null}
                                        </Grid>
                                    </Grid>
                            </Grid>
                            <Dialog
                                open={anketGoster}
                                onClose={(event, reason) => {
                                    if (reason !== 'backdropClick') {
                                        handleAnketKapat();
                                    }
                                }}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                fullWidth={true}
                                fullScreen={true}
                            >
                                <DialogContent>
                                    {loading ?
                                        <CircularProgress
                                            status={'loading'}
                                            style={{ marginLeft: '50%' }}
                                        /> : anketBitti ? mesaj
                                            : printAnket ?
                                                <ServiceDigitalFormsPrint
                                                    anketSoru={anketData}
                                                    anketCevap={formData}
                                                    formType={openedFormType}
                                                />
                                                :
                                                <>
                                                    <ServiceDigitalForms
                                                        anketSoru={anketData}
                                                        anketCevap={formData}
                                                        onComplete={onComplete}
                                                        readonly={readOnly}
                                                        serviceCodeQuestion={serviceCodeQuestion}
                                                        serviceNameQuestion={serviceNameQuestion}
                                                        serviceFullNameQuestion={serviceFullNameQuestion}
                                                        serviceShopFullName={ServiceShopFullName}
                                                    />
                                                </>
                                    }
                                </DialogContent>
                                <DialogActions sx={styles.noDisplayInPrint}>
                                    {
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => handleAnketKapat()}
                                            style={styles.button}
                                            endIcon={<CloseIcon>Close</CloseIcon>}
                                        >
                                            Kapat
                                        </Button>
                                    }
                                </DialogActions>
                            </Dialog>
                        </Grid>
                </Grid>
            </Grid >
        </div >
    );
};

export default ServiceForms;

ServiceForms.propTypes = {
    ServiceShopFullName: PropTypes.string,
    ServiceShopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
